/**
 * Copy from https://github.com/kaimallea/isMobile lib
 */

const appleIphone = /iPhone/i;
const appleTablet = /iPad/i;
const appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
const androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'
const androidTablet = /Android/i;
const otherOpera = /Opera Mini/i;
const otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
const otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'

export type UserAgent = string;

export interface Navigator {
  userAgent: string;
  platform: string;
  maxTouchPoints?: number;
}

function createMatch(userAgent: UserAgent): (regex: RegExp) => boolean {
  return (regex: RegExp): boolean => regex.test(userAgent);
}

export interface IsMobileResult {
  apple: {
    phone: boolean;
    tablet: boolean;
    universal: boolean;
    device: boolean;
  };
  android: {
    phone: boolean;
    tablet: boolean;
    device: boolean;
  };
  other: {
    opera: boolean;
    firefox: boolean;
    chrome: boolean;
    device: boolean;
  };
  phone: boolean;
  tablet: boolean;
  any: boolean;
}

export type IsMobileParameter = UserAgent | Navigator;

export default function isMobile(param?: IsMobileParameter): IsMobileResult {
  let nav: Navigator = {
    userAgent: '',
    platform: '',
    maxTouchPoints: 0,
  };

  if (!param && typeof navigator !== 'undefined') {
    nav = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      maxTouchPoints: navigator.maxTouchPoints || 0,
    };
  } else if (typeof param === 'string') {
    nav.userAgent = param;
  } else if (param && param.userAgent) {
    nav = {
      userAgent: param.userAgent,
      platform: param.platform,
      maxTouchPoints: param.maxTouchPoints || 0,
    };
  }

  const userAgent = nav.userAgent;

  const match = createMatch(userAgent);

  const result: IsMobileResult = {
    apple: {
      phone: match(appleIphone),
      tablet: !match(appleIphone) && match(appleTablet),
      universal: match(appleUniversal),
      device:
        match(appleIphone) ||
          match(appleTablet) ||
          match(appleUniversal),
    },
    android: {
      phone: match(androidPhone),
      tablet: match(androidTablet) && !match(androidPhone),
      device: match(androidPhone) || match(androidTablet),
    },
    other: {
      opera: match(otherOpera),
      firefox: match(otherFirefox),
      chrome: match(otherChrome),
      device:
        match(otherOpera) ||
        match(otherFirefox) ||
        match(otherChrome),
    },
    any: false,
    phone: false,
    tablet: false,
  };

  result.any =
    result.apple.device ||
    result.android.device ||
    result.other.device;

  // excludes 'other' devices and ipods, targeting touchscreen phones
  result.phone = result.apple.phone || result.android.phone;
  result.tablet = result.apple.tablet || result.android.tablet;

  return result;
}
